import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { TypographyComponent, TypographyVariant } from '../typography/typography.component';
import { IconComponent } from '../icon/icon.component';
import { IconValuesType } from '../icon/icon.component.types';

@Component({
  selector: 'hyperkit-tab',
  standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabComponent {
  @Input() variant: 'primary' | 'secondary' | 'tertiary' = 'primary';
  @Input() mode: 'underline' | 'text' = 'underline';
  @Input() icon: IconValuesType | null = null;
  @Input() text = '';
  @Input() disabled = false;
  @Input() count: number | null = null;
  @Input() selected = false;
  @Input() controlled = false; // ✅ Controlled mode for content

  @Output() tabClick = new EventEmitter<void>();

  @ViewChild('contentTemplate', { static: true })
  contentTemplate!: TemplateRef<any>;

  constructor(private cdr: ChangeDetectorRef) {}

  get typographyVariant(): TypographyVariant {
    switch (this.variant) {
      case 'primary':
        return 'h5';
      case 'secondary':
        return 'h6';
      case 'tertiary':
        return 'label1';
      default:
        return 'body1';
    }
  }

  onTabClick(): void {
    if (!this.disabled) {
      if (!this.controlled) {
        this.selected = true;
      }
      this.tabClick.emit();
    }
  }

  deselect(): void {
    this.selected = false;
    this.cdr.markForCheck();
  }
}
